import {
  AUTHENTICATION_USER_SIGNIN,
  AUTHENTICATION_USER_SIGNOUT,
  AUTHENTICATION_SWITCH_SIGNIN_PROCESS,
  LOCALIZATION_SET_USERS_REGION_AND_LANGUAGE,
  AUTHENTICATION_USER_UPDATEDATA,
} from "../lib/types";

export const switchIsSigningInProcess = (isSigningIn) => (dispatch) => {
  dispatch({
    type: AUTHENTICATION_SWITCH_SIGNIN_PROCESS,
    payload: isSigningIn,
  });
};

export const loginUser = (info) => (dispatch) => {
  dispatch({
    type: AUTHENTICATION_USER_SIGNIN,
    payload: {
      user: {
        ...info.user,
        county: info.county ? info.county._ : null,
        mailingList: info.mailingList ? info.mailingList._ : null,
      },
      b2cData: info.b2cData,
      idToken: info.idToken,
      accessToken: info.accessToken,
      resourcesTokens: info.resourcesTokens,
    },
  });
  dispatch({
    type: LOCALIZATION_SET_USERS_REGION_AND_LANGUAGE,
    payload: info.userData,
  });
  dispatch({
    type: AUTHENTICATION_SWITCH_SIGNIN_PROCESS,
    payload: false,
  });
};

export const updateUserData = (info) => (dispatch) => {
  dispatch({
    type: AUTHENTICATION_USER_UPDATEDATA,
    payload: {
      ...info,
    },
  });
};

export const logoutUser = () => (dispatch) => {
  dispatch({
    type: AUTHENTICATION_USER_SIGNOUT,
  });
};



// WEBPACK FOOTER //
// ./src/actions/authentication-actions.js